import { Type } from "@angular/core";
import { employees, employee, stores, store, jobs, managers } from "./models/universal-json";
import { UserComponent } from "./pages/user/user.component";
import { UniversalCrudComponent, UniversalDetailsComponent } from "@stdoutsrl/design-kit";
import { EmployeeSheetComponent } from "./pages/calendar/calendar.component";
import { CalendarioMiglioreComponent } from "./pages/calendario-migliore/calendario-migliore.component";
import { ReportComponent } from "./pages/report/report.component";

export const routingTranslated: RouteTranslatedInterface[] = [
  {
    component: UniversalCrudComponent,
    data: employees,
    paths: ["dipendenti", "employees"],
    titles: ["Dipendenti", "Employees"],
    breadcrumbIndex: 0,
  },
  {
    component: UniversalCrudComponent,
    data: jobs,
    paths: ["lavori", "jobs"],
    titles: ["Lavori", "Jobs"],
    breadcrumbIndex: 0,
  },
  {
    component: UniversalCrudComponent,
    data: managers,
    paths: ["gestori", "managers"],
    titles: ["Gestori", "Managers"],
    breadcrumbIndex: 0,
  },
  {
    component: UniversalCrudComponent,
    data: stores,
    paths: ["punti-vendita"],
    titles: ["Punti vendita"],
    breadcrumbIndex: 0,
  },
  {
    component: UniversalDetailsComponent,
    data: store,
    paths: ["punto-vendita/:id"],
    titles: ["Punto vendita"],
    breadcrumbIndex: 1,
  },
  {
    component: EmployeeSheetComponent,
    data: {
      breadcrumb: [
        {
          title: "Calendario turni",
          route: "/calendario-turni",
        },
      ],
    },
    paths: ["calendario-turni"],
    titles: ["Calendario turni"],
    breadcrumbIndex: 0,
  },
  {
    component: CalendarioMiglioreComponent,
    data: {
      breadcrumb: [{ title: "Lista turni", route: "/calendario-migliore" }],
    },
    paths: ["calendario-migliore"],
    titles: ["Lista turni"],
    breadcrumbIndex: 0,
  },
  {
    component: ReportComponent,
    data: {
      breadcrumb: [
        {
          title: "Resoconto",
          route: "/resoconto",
        },
      ],
    },
    paths: ["resoconto"],
    titles: ["Resoconto"],
    breadcrumbIndex: 0,
  },
  {
    component: UniversalDetailsComponent,
    data: employee,
    paths: ["dipendente/:id", "employee/:id"],
    titles: ["Dipendente", "Employee"],
    breadcrumbIndex: 0,
  },
  {
    paths: ["profile", "profilo"],
    titles: ["Profile", "Profilo"],
    component: UserComponent,
    data: {
      breadcrumb: [
        {
          title: "Profilo utente",
          route: "/profilo",
        },
      ],
    },
    breadcrumbIndex: 0,
  },
];

export interface RouteTranslatedInterface {
  component: Type<any>;
  data?: any;
  paths: string[];
  titles: string[];
  breadcrumbIndex: number;
}
